import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import './index.css';

// Session auth relies on a cookie — needed on every request so the login
// state and API calls all share the same session, including in local dev
// where the client (3000) and API (3001) are different origins.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
